import {
  Mixins,
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { ITABLECOLCONF } from '@/types/base.d';
import api from '@/api/set';
import publicApi from '@/api/public';
import pageMixin from '../../../../mixins/pageMixin';


@Component
export default class tableMixin extends Mixins(pageMixin) {
  @Prop({
    type: String,
    required: true,
  }) type!: string;

  @Prop({
    default: false,
  }) typeList!: any;

  private sList: any = [];

  public column: Array<ITABLECOLCONF> = [{
    label: '名称',
    prop: 'title',
    align: 'center',
    tooltip: true,
  }, {
    label: '创建时间',
    prop: 'createAt',
    align: 'center',
  }, {
    label: '操作',
    custom: true,
    minWidth: '120',
    maxBtn: 2,
    btnList: [
      {
        title: '编辑',
        name: '/set/normal:update',
        icon: 'edit',
        type: 'info',
        callback: this.handleUpdateForm,
        log: {
          name: '系统配置 - 编辑',
          component: 'set/tableMixin',
        },
      },
      // {
      //   title: '删除',
      //   name: '/set:remove',
      //   icon: 'remove',
      //   type: 'info',
      //   callback: this.handleRmove,
      //   log: {
      //     name: '系统配置 - 删除',
      //     component: 'set/tableMixin',
      //   },
      // },
    ],
    align: 'center',
  }];

  public columnCopy = this.column.concat()

  private loading: boolean = true;

  public difficulties: any = [];

  private tableFlag: boolean = true;

  mounted() {
    this.getData(this.type);
  }

  /* eslint-disable class-methods-use-this */
  /**
   * @author ruixue
   * @desc 获取配置列表
   */
  getData(type: string) {
    this.tableFlag = false;
    this.column = this.columnCopy.concat();
    this.loading = true;
    api.getActivityBanner(this.page).then((res: any) => {
      this.sList = res.content;
      this.total = res.totalElements;
      this.loading = false;
      this.tableFlag = true;
    });
  }

  /* eslint-disable class-methods-use-this */
  handleUpdateForm(row: any) {}

  /**
   * @author ruixue
   * @desc 删除配置操作
   * @param { any } row 行数据
  */
  handleRmove(row: any) {
    this.confirm('此操作将永久删除该数据, 是否继续?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.removeconfig({ id: row.pid }).then(() => {
        this.getData(this.type);
        close();
        this.$log({
          title: '系统配置 - 删除 - 确定',
          component: 'org/manage/tableMixin',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '系统配置 - 删除 - 取消',
      component: 'org/manage/tableMixin',
    }));
  }
}
